import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { usePaddle } from '../../hooks/usePaddle'
import { Lock, Zap, Bell } from 'lucide-react'
import Logo from '../ui/Logo'
import styles from './PaywallGate.module.css'

export default function PaywallGate({ children }) {
  const { profile } = useAuth()
  const { openCheckout } = usePaddle()
  const navigate = useNavigate()

  if (!profile) return null

  const { subscription_status, trial_ends_at } = profile

  const isExpired = (() => {
    if (subscription_status === 'active') return false
    if (subscription_status === 'expired' || subscription_status === 'cancelled') return true
    if (subscription_status === 'trialing') {
      if (!trial_ends_at) return false
      return new Date() > new Date(trial_ends_at)
    }
    return false
  })()

  if (!isExpired) return children

  return (
    <div className={styles.fullPage}>
      <div className={styles.card}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <Logo variant="full" size="lg" />
        </div>
        <div className={styles.iconWrap}>
          <Lock size={28} color="#1570C8" />
        </div>
        <h2 className={styles.title}>Your Free Trial Has Ended</h2>
        <p className={styles.desc}>
          Upgrade to Debnix Pro to access your inventory predictions,
          supplier management, and AI email drafts.
        </p>
        <div className={styles.features}>
          {[
            'AI stockout predictions',
            'Supplier email drafts',
            'Surge mode',
            'Real-time Shopify sync',
          ].map((f, i) => (
            <div key={i} className={styles.featureItem}>
              <Zap size={13} color="#1570C8" />
              <span>{f}</span>
            </div>
          ))}
        </div>
        <div className={styles.pricing}>
          <span className={styles.price}>$21.99</span>
          <span className={styles.pricePer}>/month</span>
        </div>
        <button className={styles.upgradeBtn} onClick={() => openCheckout()}>
          <Zap size={16} />
          Upgrade Now
        </button>
        <button
          className={styles.alertsLink}
          onClick={() => navigate('/alerts')}
        >
          <Bell size={14} />
          View Alerts
        </button>
        <p className={styles.note}>Cancel anytime · No contracts</p>
      </div>
    </div>
  )
}